import { useState, useEffect } from "react";

import { Popper, Paper, Typography } from "@material-ui/core";

import {
  controlButton,
  ulStyle,
  liStyle,
  inputStyle,
} from "./MapButtonStyling";
import { getMapSettings, handleBoundaryStrokeToggle } from "./MapLayers";

const MapLayerController = ({
  options,
  map,
  showIncidentToggle = false,
  toggleShowIncidents,
  showIncidents = true,
  showOfficerToggle = false,
  toggleShowOfficers,
  showOfficers = true,
  showDirectionsButton = false,
  toggleShowDirections = () => {},
  directionsOpen = false,
  showRouteButton = false,
  toggleShowRoute = () => {},
  routeOpen = false,
  showOfficerAccuracy = false,
  toggleShowOfficerAccuracy = () => {},
  userId,
  openMenu,
  setOpenMenu,
}) => {
  const [localOpenMenu, setLocalOpenMenu] = useState(null);
  const menuControlled = openMenu !== undefined && setOpenMenu;
  const activeOpenMenu = menuControlled ? openMenu : localOpenMenu;
  const setActiveOpenMenu = menuControlled ? setOpenMenu : setLocalOpenMenu;
  const [mapSettings, setMapSettings] = useState(() => getMapSettings(userId));
  const [hover, setHover] = useState(false);
  const rootElement = document.getElementById("app");
  const [popperOpen, setPopperOpen] = useState(false);
  const [popperContent, setPopperContent] = useState("");

  useEffect(() => {
    setMapSettings(getMapSettings(userId));
  }, [userId]);

  useEffect(() => {
    function tooMuch() {
      setPopperContent("Too many results. Please zoom in.");
      setPopperOpen(true);
      const timer = setTimeout(() => {
        setPopperOpen(false);
        setPopperContent("");
      }, 3000);
      return () => clearInterval(timer);
    }
    window.addEventListener("exceedsTransferLimit", tooMuch);
    return () => {
      window.removeEventListener("exceedsTransferLimit", tooMuch);
    };
  }, []);

  const toggleMenu = menuName => {
    setActiveOpenMenu(prev => (prev === menuName ? null : menuName));
  };

  const handleWhiteBoundaryChange = e => {
    const settings = handleBoundaryStrokeToggle(e.target.checked, userId);
    setMapSettings(settings);
  };

  return (
    <div>
      <div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ position: "relative" }}>
            <button
              type="button"
              onMouseEnter={() => setHover("layers")}
              onMouseLeave={() => setHover(false)}
              onClick={() => toggleMenu("layers")}
              style={controlButton(hover === "layers")}
            >
              Layers
            </button>
            <ul
              data-testid="layers-menu"
              style={{
                ...ulStyle,
                ...{
                  display: activeOpenMenu === "layers" ? "inherit" : "none",
                },
              }}
            >
              {showIncidentToggle && (
                <li style={liStyle} key={"incidents"}>
                  <input
                    style={inputStyle}
                    id={"incidents-input"}
                    type="checkbox"
                    name={"incidents"}
                    checked={showIncidents}
                    onChange={toggleShowIncidents}
                  />
                  <label htmlFor={"incidents-input"}>Incidents</label>
                </li>
              )}
              {showOfficerToggle && (
                <li style={liStyle} key={"officers"}>
                  <input
                    style={inputStyle}
                    id={"officers-input"}
                    type="checkbox"
                    name={"officers"}
                    checked={showOfficers}
                    onChange={toggleShowOfficers}
                  />
                  <label htmlFor={"officers-input"}>Officers</label>
                </li>
              )}
              {showOfficerToggle && (
                <li style={liStyle} key={"officer-accuracy"}>
                  <input
                    style={inputStyle}
                    id={"officer-accuracy-input"}
                    type="checkbox"
                    name={"officer-accuracy"}
                    checked={showOfficerAccuracy}
                    onChange={toggleShowOfficerAccuracy}
                  />
                  <label htmlFor={"officer-accuracy-input"}>
                    Show Officer Accuracy
                  </label>
                </li>
              )}
              {options.map((o, i) => {
                const { handler, label } = o || {};
                return (
                  <li style={liStyle} key={label + i}>
                    <input
                      style={inputStyle}
                      id={label}
                      type="checkbox"
                      name={label}
                      onChange={e =>
                        handler(e.target.checked, label, map, mapSettings)
                      }
                    />
                    <label htmlFor={label}>{label}</label>
                  </li>
                );
              })}
            </ul>
          </div>
          {showRouteButton && (
            <button
              type="button"
              onMouseEnter={() => setHover("route")}
              onMouseLeave={() => setHover(false)}
              onClick={toggleShowRoute}
              style={controlButton(hover === "route")}
            >
              {!routeOpen ? "Show" : "Hide"} Route
            </button>
          )}
          {showDirectionsButton && (
            <button
              type="button"
              onMouseEnter={() => setHover("directions")}
              onMouseLeave={() => setHover(false)}
              onClick={toggleShowDirections}
              style={controlButton(hover === "directions")}
            >
              {!directionsOpen ? "Show" : "Hide"} Directions
            </button>
          )}
          <div style={{ position: "relative" }}>
            <button
              type="button"
              onMouseEnter={() => setHover("options")}
              onMouseLeave={() => setHover(false)}
              onClick={() => toggleMenu("options")}
              style={controlButton(hover === "options")}
            >
              Options
            </button>
            <ul
              data-testid="options-menu"
              style={{
                ...ulStyle,
                ...{
                  display: activeOpenMenu === "options" ? "inherit" : "none",
                },
              }}
            >
              <li style={liStyle} key={"white-boundary"}>
                <input
                  style={inputStyle}
                  id={"white-boundary-input"}
                  type="checkbox"
                  name={"whiteBoundary"}
                  checked={!!mapSettings.whiteBoundary}
                  onChange={handleWhiteBoundaryChange}
                />
                <label htmlFor={"white-boundary-input"}>
                  White boundary lines
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Popper
        placement="top"
        open={popperOpen}
        disablePortal={false}
        anchorEl={rootElement}
        modifiers={{
          flip: {
            enabled: false,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: "viewport",
          },
        }}
      >
        <Paper style={{ padding: "10px" }}>
          <Typography style={{ fontWeight: "bold" }}>
            {popperContent}
          </Typography>
        </Paper>
      </Popper>
    </div>
  );
};

export default MapLayerController;
